import moment from "moment";
import { QueryStringArgumentSerializer } from "./QueryStringArgumentSerializer";

const unspecifiedArgumentValue = 'unspecified';

export class DateArgumentSerializer
    extends QueryStringArgumentSerializer<Date | null> {
    private acceptTime: boolean;

    constructor(
        key: string,
        onDeserializeCallback?: (value: Date | null) => void,
        acceptTime?: boolean
    ) {
        super(key, undefined, onDeserializeCallback);
        this.acceptTime = acceptTime ?? false;
    }

    dateFormat = 'YYYY-M-D';
    alternateDateFormats = ['YYYY-M-DD', 'YYYY-MM-D', 'YYYY-MM-DD'];
    timeFormat = 'THH:mm:ss';

    parseDate = (value: string) => {
        const formats = [this.dateFormat, ...this.alternateDateFormats];
        let i = 0;

        do {
            const format = this.acceptTime ? formats[i] + this.timeFormat : formats[i];
            const date = moment(value, format, true);

            if (date.isValid()) {
                return date;
            }

        } while (++i < formats.length);

        return undefined;
    }

    serialize = (value: Date | undefined | null) => {
        if (value === null) {
            return unspecifiedArgumentValue
        }

        const template = this.acceptTime ? this.dateFormat + this.timeFormat : this.dateFormat;

        return value ? moment(value).format(template) : undefined
    };

    deserialize = (rawValue: string): void => {
        const value = rawValue ? decodeURIComponent(rawValue.trim()) : undefined;

        if (this.onDeserializeCallback) {
            if (value === unspecifiedArgumentValue) {
                this.onDeserializeCallback(null);
            } else {
                const date = value && this.parseDate(value);
                if (date && date.isValid()) {
                    if (this.acceptTime) {
                        this.onDeserializeCallback(date.toDate());
                    } else {
                        this.onDeserializeCallback(date.startOf('day').toDate());
                    }
                }
            }
        }
    }
}
